import { memo, SVGProps } from 'react'

function Plus(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 36 36"
      width={props.width}
      height={props.height ?? props.width}
    >
      <path
        fill={props.fill}
        d="M34.847 11.647a1.332 1.332 0 10-2.493.94 15.349 15.349 0 11-5.78-7.3 1.335 1.335 0 101.493-2.213 17.974 17.974 0 106.78 8.573z"
      />
      <path
        fill={props.fill}
        d="M18.001 27.706a1.337 1.337 0 001.333-1.333v-7.04h7.04a1.333 1.333 0 000-2.667h-7.04v-7.04a1.333 1.333 0 10-2.667 0v7.04h-7.04a1.333 1.333 0 100 2.667h7.04v7.04a1.333 1.333 0 001.334 1.333z"
      />
    </svg>
  )
}

Plus.defaultProps = {
  width: 36,
  fill: '#006ba6'
}

export default memo(Plus)
